<template>
  <meta-item icon="globe">
    <template v-slot:key>End Date:</template>
    {{ booking.date | date($user.date_format_preference) | nullable }}
  </meta-item>
</template>

<script>
import MetaItem from './MetaItem'

export default {
  components: {
    MetaItem
  },
  props: {
    booking: {
      type: Object,
      required: true
    }
  }
}
</script>
